
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2_QOl9TI3pJdy4im_45twWHIWrals948aADSl9Q1xMsQoMeta } from "/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/index.vue?macro=true";
import { default as _403i_XDBp4TuLgtgaQ5xfqzU5P7vjVFDwGiIGNNr1XOiIcMeta } from "/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/403.vue?macro=true";
import { default as _404lbaNWIOFsEi3b3CgqHwQyzN7WGcOihIsBWNmsDBRYUoMeta } from "/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/404.vue?macro=true";
import { default as countryselection7d6WYYbZC7__45Ac_45sGxsWkbOWygsY7uvGqFyrY8td124Meta } from "/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/countryselection.vue?macro=true";
import { default as _403_userextrasGEwwoNXx921u2fVN56VSe1QlyYpksL_4562DPQ0sOaYyUMeta } from "/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/403_userextras.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/index.vue")
  },
  {
    name: "errors-403",
    path: "/errors/403",
    component: () => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/403.vue")
  },
  {
    name: "errors-404",
    path: "/errors/404",
    component: () => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/404.vue")
  },
  {
    name: "countryselection",
    path: "/countryselection",
    meta: countryselection7d6WYYbZC7__45Ac_45sGxsWkbOWygsY7uvGqFyrY8td124Meta || {},
    alias: ["/business/agreement/posting","/business/agreement/application","/accessibility","/apply","/hokifycv","/jobalarm","/jobalarm/:jobalarmId/:subId?","/privacy","/a/:alias","/seamless-login/:loginId/:loginToken","/verify/:userid/:code","/app","/pwa","/user","/saved","/review-profile","/user-profile","/user-settings","/notification-settings","/my-cv","/notifications","/webupload/:docType","/match/:matchId","/job/:jobNr/:uref?","/apply/:jobNr","/apply-company/:companyId","/save/:jobNr","/discard/:jobNr","/discard-suggestion/:jobNr","/company","/app/company","/pwa/company","/organization","/demo","/addcredit/:priceIdORCoupon?/:couponORContingent?","/addjob","/addjob/:priceIdORCoupon/:coupon?","/addcredit","/pricelist","/app/company/:jobNr","/app/company/:jobNr/edit","/candidate/:jobNr/:matchId","/candidate-company/:companyId/:matchId","/company-referral","/company-privacy","/candidates/:jobId","/company-profile","/upgradejob/:jobId/:priceIdRCoupon?/:coupon?","/jobclaim/:code/:jobNr","/app/user","/app/login","/jobs/m/:branche/:location","/jobs/k/:branche","/jobs/l/:location","/c/:company","/disclaimer"],
    component: () => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/countryselection.vue")
  },
  {
    name: "errors-403_userextras",
    path: "/errors/403_private_files",
    meta: _403_userextrasGEwwoNXx921u2fVN56VSe1QlyYpksL_4562DPQ0sOaYyUMeta || {},
    alias: ["/userextra/:extra","/userextra%2F%3Aextra"],
    component: () => import("/home/runner/work/hokify/hokify/apps/international-page-app/src/pages/errors/403_userextras.vue")
  }
]